import ErrorsVue from '@/views/errors/errors.vue';

const basePath = '/error';

export const ERROR_404 = 'error_404';
export const ERROR_422 = 'error_422';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/404`,
  component: ErrorsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/404`,
      name: ERROR_404,
      component: () => import(
        /* webpackChunkName: "errors" */
        '@/views/errors/404.vue'
      ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: `${basePath}/422`,
      name: ERROR_422,
      component: () => import(
        /* webpackChunkName: "errors" */
        '@/views/errors/422.vue'
      ),
      meta: {
        requiresAuth: true
      }
    }
  ]
};
